import React from 'react';
import { Mail, Phone, MapPin, Users, Calendar } from 'lucide-react';
import Button from '../../../components/ui/Button';

const EmployeeCard = ({ employee, onClick, department }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-green-100 text-green-800';
      case 'inactive':
        return 'bg-red-100 text-red-800';
      case 'on_leave':
        return 'bg-yellow-100 text-yellow-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getEmploymentTypeLabel = (type) => {
    switch (type) {
      case 'ft':
        return 'Full-time';
      case 'pt':
        return 'Part-time';
      case 'contract':
        return 'Contract';
      default:
        return 'Full-time';
    }
  };

  const formatStartDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString)?.toLocaleDateString();
  };

  return (
    <div 
      className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow cursor-pointer"
      onClick={onClick}
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center">
          <div className="h-12 w-12 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white font-semibold text-lg mr-4">
            {employee?.firstName?.charAt(0) || 'U'}{employee?.lastName?.charAt(0) || 'N'}
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 text-lg">
              {employee?.firstName || 'Unknown'} {employee?.lastName || 'Name'}
            </h3>
            <p className="text-sm text-gray-600">
              {employee?.title || 'No title assigned'}
            </p>
          </div>
        </div>
        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(employee?.status)}`}>
          {employee?.status || 'active'}
        </span>
      </div>
      {/* Employee Details */}
      <div className="space-y-3 mb-4">
        <div className="flex items-center text-sm text-gray-600">
          <Mail className="h-4 w-4 mr-2 text-gray-400" />
          <span className="truncate">{employee?.email || 'No email'}</span>
        </div>
        
        {employee?.phone && (
          <div className="flex items-center text-sm text-gray-600">
            <Phone className="h-4 w-4 mr-2 text-gray-400" />
            <span>{employee?.phone}</span>
          </div>
        )}

        <div className="flex items-center text-sm text-gray-600">
          <MapPin className="h-4 w-4 mr-2 text-gray-400" />
          <span>{employee?.location || 'Remote'}</span>
        </div>

        <div className="flex items-center text-sm text-gray-600">
          <Users className="h-4 w-4 mr-2 text-gray-400" />
          <span>{department?.name || 'No department'}</span>
        </div>

        <div className="flex items-center text-sm text-gray-600">
          <Calendar className="h-4 w-4 mr-2 text-gray-400" />
          <span>Started {formatStartDate(employee?.startDate)}</span>
        </div>
      </div>
      {/* Employment Type Badge */}
      <div className="mb-4">
        <span className="inline-flex px-2 py-1 text-xs font-medium rounded-md bg-blue-50 text-blue-700">
          {getEmploymentTypeLabel(employee?.employmentType)}
        </span>
      </div>
      {/* Action buttons */}
      <div className="flex space-x-2">
        <Button 
          variant="ghost" 
          size="sm" 
          className="flex-1"
          onClick={(e) => {
            e?.stopPropagation();
            // TODO: Open email client
            console.log('Send email to:', employee?.email);
          }}
        >
          <Mail className="h-4 w-4 mr-1" />
          Message
        </Button>
        <Button 
          variant="ghost" 
          size="sm" 
          className="flex-1"
          onClick={(e) => {
            e?.stopPropagation();
            // TODO: Open profile view
            console.log('View profile:', employee?.id);
          }}
        >
          View Profile
        </Button>
      </div>
    </div>
  );
};

export default EmployeeCard;